const PUBLIC_PATHS = [
  "/",
  "/login",
  "/signup",
  "/about",
  "/auth/callback",
  "/auth/saml/callback",
];

/** Routes that do not require an authenticated session. */
export function isPublicPath(pathname: string): boolean {
  const normalized = pathname.endsWith("/") ? pathname : `${pathname}/`;
  if (normalized === "/") return true;
  return PUBLIC_PATHS.some((route) => {
    if (route === "/") return false;
    const publicRoute = route.endsWith("/") ? route : `${route}/`;
    return normalized.startsWith(publicRoute);
  });
}
